import { render, staticRenderFns } from "./ChangeProductOrgModal.vue?vue&type=template&id=5086ff44&"
import script from "./ChangeProductOrgModal.vue?vue&type=script&lang=ts&"
export * from "./ChangeProductOrgModal.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports